

const IMAGES= {
    SID:{
         bgMain:require('./SID/sidbackground.webp').default,
         bgRight:require('./SID/banner_image-right2x_2.webp').default,
         cicon1:require('./SID/cicon1.svg').default,
         cicon2:require('./SID/cicon2.svg').default,
         cicon3:require('./SID/cicon3.svg').default,
         cicon4:require('./SID/cicon4.svg').default,
         dayHour:require('./SID/dayhour.webp').default,
        is:require('./SID/is.svg').default,
        gf:require('./SID/gf.svg').default,
        si:require('./SID/si.svg').default,
        dbFlow:require('./SID/sid-work.svg').default,
        apparel:require('./SID/apparel.webp').default,
        electronics:require('./SID/electronics.webp').default,
        automotive:require('./SID/automotive.webp').default,
        pharma:require('./SID/pharma.webp').default,
        sidIcon1:require('./SID/sid-icon1.webp').default,
        sidIcon2:require('./SID/sid-icon2.webp').default,
        sidIcon3:require('./SID/sid-icon3.webp').default,
        yellowBg:require('./SID/yellow-bg.webp').default,
        blueBg:require('./SID/blue-bg.webp').default,
    },
    DOMESTIC:{
        banner:require('./domestic.svg').default,
        crediline:require('./Group-25844.svg').default,
        digitalprocess:require('./invoice-discounting/Group-25849.svg' ).default,
        finance:require('./invoice-discounting/Group-25851.svg' ).default,
        clock:require('./invoice-discounting/Group-25850.svg' ).default,
    },
    BRANDIMG:{
        twiga:require('./brand-img/twigaweb@2x.png').default,
        lucro:require('./brand-img/lucro@2x.png').default,
        foodlogo:require('./brand-img/foodlogo@2x.png').default,
        logocompany:require('./brand-img/Logo-Company-1_000-1@2x.png').default,
        aditya:require('./brand-img/Group-28018@2x.png').default,
    },
    FOOTER:{
        fb:require('./social-icon/Facebook.png').default,
        xLogo:require('./social-icon/x-logo.svg').default,
        linkedIn:require('./social-icon/linkedin.png').default
    },

    SHARED:{
        credlixLogo:require('./Shared/credlix-logo.png').default,
        favIcon : require('./favicon.png').default, 
        eFinance:require('./header-images/Export-factoring.svg').default,
        poFinane:require('./header-images/PO-Finance.svg').default,
        sbDiscount:require('./header-images/Sales-Bill-Discounting.svg').default,
        ePayment:require('./header-images/Early-Payment.svg').default,
        vFinance:require('./header-images/Vendor-Finance.svg').default,
        cFinance:require('./header-images/Channel-Finance.svg').default,
        pProgram:require('./header-images/partnerLogo.svg').default,
        loanLogo:require('./header-images/LoanLogo.svg').default,
        HSNFinder:require('./header-images/hsn-Finder-icon.svg').default,
        HTSFinder:require('./header-images/HTS-Finder-Icon.svg').default,
        MexicoImportDuty:require('./header-images/Mexico_Import_Icon.svg').default,
        iCalc:require('./header-images/Interst-calc-icon.svg').default,
        businessLoanCalcIcon:require('./header-images/Business-Loan-Calc-Icon.svg').default,
        shipmentCalculator:require('./header-images/shipment-Calc-icon.svg').default,
        gstSearchIcon:require('./header-images/gst-search-icon.svg').default,
        indiaLogo:require('./header-images/india-logo.webp').default,
        mexicoLogo:require('./header-images/mexico-logo.webp').default,
        usaLogo:require('./header-images/usa-icon.webp').default,
        newCredlixLogoIcon:require('./Shared/credlixLogoIcon.svg').default,
        ftIcon1:require('./Shared/ftIcon1.svg').default,
        ftIcon2:require('./Shared/ftIcon2.svg').default,
        ftIcon3:require('./Shared/ftIcon3.svg').default,
        ftIcon4:require('./Shared/ftIcon4.svg').default,
        importLogo:require('./Shared/importLogo.svg').default,
        pidLogo:require('./Shared/pidLogo.svg').default,
        credlixRemit:require('./header-images/Credlix-Remit.svg').default,
        blogIcon:require('./header-images/Blogs-icon.svg').default,
        caseStudyIcon:require('./header-images/Case-Study-Icon.svg').default,
        newsIcon:require('./header-images/News-Icon.svg').default,
        webinarIcon:require('./header-images/Webinar-Icon.svg').default,
        eventIcon:require('./header-images/Events-icons.svg').default,
        videoIcon:require('./header-images/Videos-Icons.svg').default,
        glossaryIcon:require('./header-images/Glossary-Icon.svg').default,
    },

    EXPLOREIMG: {
        bannerExporter1:require('./export-financing/export-financeBannerVideoThumb.png').default,
        domesticimg:require('./explore-img.png').default,
        hcwfe:require('./exporter-boy.png').default,
        hcwfe_mb:require('./exporter-boy-mb.png').default,
        upfina:require('./Group-25841.svg').default,
        intsolu:require('./Group-25842.svg').default,
        purchorder:require('./Group-27532@2x.png').default,
        wallet:require('./Group-25843.svg').default,
        handblue:require('./Group-25844.svg').default,
    },
    INVOICEDISCOUNTING:{
        banner:require('./invoice-discounting/Group-27888.svg').default,
        icon:require('./invoice-discounting/Group-26916.svg').default,
        clockimg:require('./invoice-discounting/Group-25850.svg').default,
        invoicefina:require('./invoice-discounting/Group-25851.svg').default,
        digipro:require('./invoice-discounting/Group-25852.svg').default,
        credline:require('./invoice-discounting/Group-25849.svg').default,
    },
    EARLYPAYMENTIMG: {
        banner:require('./early-payment/early-payment-banner.svg').default,
        break:require('./early-payment/Group-25833.svg').default,
        workflow:require('./early-payment/Group-25834.svg').default,
        easyon:require('./early-payment/Group-25832.svg').default,
        longtail:require('./early-payment/Group-25831.svg').default,
        cardimg:require('./early-payment/Group-25755.svg').default,
        cardimgright:require('./early-payment/Group-25756.svg').default,
        droparrow:require('./early-payment/Group-28011.svg').default,
        earlypaymentBackground:require('./early-payment/earlypaymentBackground.svg').default,

    },
    VENDORPAYMENTIMG:{
        banner:require('./vendor-finance/Group-25488-1.svg').default,
        easyvendorimg:require('./vendor-finance/Group-25835.svg').default,
        multivendorimg:require('./vendor-finance/Group-25836.svg').default,
        crediline:require('./vendor-finance/Group-25847.svg').default,
        workflowsimg:require('./vendor-finance/Group-25838.svg').default,
        cardimg:require('./vendor-finance/Group-25761-1.svg').default,
    },

    CHANNELFINANCEIMG:{
        bannerChannelFinancing:require('./channel-finance/channel-Financing-Banner.png').default,
        banner_mb:require('./channel-finance/Channel-New-mb.png').default,
        funding:require('./channel-finance/Group-25845.svg').default,
        flexible:require('./channel-finance/Group-25839.svg').default,
        digital:require('./channel-finance/Group-25840.svg').default,
    },
    HOMEIMG:{
        bigLogoNew:require('./home-page-new/Credlix-big-logo.webp').default,
        homeBanner:require('./home-page-new/desktopBanner.png').default,
        sequoia:require('./investors-img/Sequoia_svg@2x.png').default,
        accel:require('./investors-img/Accel_logo@2x.png').default,
        falcon:require('./investors-img/falcon@2x.png').default,
        havard:require('./investors-img/havard_logo2x.png').default,
        tiger:require('./investors-img/tiger-global2x.png').default,
        jungle:require('./investors-img/jungle2x.png').default,
        testimonialReadmore:require('./Group__30310.png').default,
        aylf_popupimg:require('./investors-img/aylf_popup.png').default,
        whatsAppLogo:require('./investors-img/WhatsApp.svg').default,
        ashleyLogo:require('./investors-img/ashley.webp').default,
        homeGoodsLogo:require('./investors-img/homeGoods.webp').default,
        geLogo:require('./investors-img/ge.webp').default,
        rossLogo:require('./investors-img/ross.webp').default,
        spacexLogo:require('./investors-img/spacex.webp').default,
        tjxLogo:require('./investors-img/tjx.webp').default,
        walMart:require('./investors-img/walmart.webp').default,
        mexicoHomeNew:require('./home-page-new/mx/homebanner.webp').default,
        mexicoHomeMobile:require('./home-page-new/mx/homebannerMobile.webp').default,
    },
    
    HomeNew:{
        vendorFinance:require('./home-page-new/vendor-finance-home.svg').default,
        dealerFinance:require('./home-page-new/dealer-finance.svg').default,
        channelFinance:require('./home-page-new/channel-finance-home.svg').default,
        buyerFinance:require('./home-page-new/buyer-finance.svg').default,
        lastMileFinance:require('./home-page-new/last-mile-finance.svg').default,
        importFinancing:require('./home-page-new/import-financing.svg').default,
        shipImgNew:require('./home-page-new/ship-2.webp').default,
        shipMb:require('./home-page-new/ship-2-mb.webp').default,
        truckImgNew:require('./home-page-new/truck-2.webp').default,
        truckMb:require('./home-page-new/truck-2-mb.webp').default,
        numbersBg:require('./home-page-new/num-bg.webp').default,
        numbersBgMobile:require('./home-page-new/num-bg_mobile.webp').default,
        yellowRoad:require('./home-page-new/road-bg.webp').default,
        yellowRoadMb:require('./home-page-new/road-bg-mb.webp').default,
        yellowBg:require('./home-page-new/yellow-bg.webp').default,
        yellowBgMb:require('./home-page-new/yellow-bg-mb.webp').default,
        blueSea:require('./home-page-new/sea-bg.webp').default,
        blueSeaMb:require('./home-page-new/sea-bg-mb.webp').default,
        blueBg:require('./home-page-new/blue-bg.webp').default,
        blueBgMb:require('./home-page-new/blue-bg-mb.webp').default,
        funds:require('./home-page-new/funds.svg').default,
        securityLoan:require('./home-page-new/security-loan.svg').default,
        workingCapital:require('./home-page-new/working-capital.svg').default,
        credit:require('./home-page-new/credit.svg').default,
        hassleFree:require('./home-page-new/hassle-free.svg').default,
        secure:require('./home-page-new/secure.svg').default,
        termsheetClock:require('./home-page-new/clock_button.svg').default,
        newVideoBanner:require('./home-page-new/video-new-banner.jpg').default,
        sequoiaNew:require('./home-page-new/sequoia.png').default,
        accelNew:require('./home-page-new/accel.png').default,
        falconNew:require('./home-page-new/falocon.png').default,
        havardNew:require('./home-page-new/harvard.png').default,
        tigerNew:require('./home-page-new/tiger-global.png').default,
        jungleNew:require('./home-page-new/jungle.png').default,
        quoteImg:require('./home-page-new/quote.svg').default,
        adityaImg:require('./home-page-new/aditya.png').default,
        lucroImg:require('./home-page-new/lucro.png').default,
        accordImg:require('./home-page-new/accord.png').default,
        twigaImg:require('./home-page-new/twiga.png').default,
        vinodImg:require('./home-page-new/vinod.png').default,
        falconEdge:require('./home-page-new/falcon_1.webp').default,
        tigerGlobal:require('./home-page-new/tigerGlobal.webp').default,
        seedPlus:require('./home-page-new/seedPlus.webp').default,
        compositeCapital:require('./home-page-new/compositeCapital_1.webp').default,
        infinanceCorp:require('./home-page-new/ifcLogo_1.webp').default,
        worldMap:require('./home-page-new/map.webp').default,
        indiaFlag:require('./home-page-new/india.webp').default,
        mexicoFlag:require('./home-page-new/mexico.webp').default,
        singaporeFlag:require('./home-page-new/singapore.webp').default,
        usaFlag:require('./home-page-new/usa.webp').default,
        uaeFlag:require('./home-page-new/uae.webp').default,
        award1:require('./home-page-new/awards/award1.webp').default,
        award2:require('./home-page-new/awards/award2.webp').default,
        award3:require('./home-page-new/awards/award3.webp').default,
        award4:require('./home-page-new/awards/award4.webp').default,
        award5:require('./home-page-new/awards/award5.webp').default,
        award6:require('./home-page-new/awards/award6.webp').default,
        award7:require('./home-page-new/awards/award7.webp').default,
        award8:require('./home-page-new/awards/award8.webp').default,
        award9:require('./home-page-new/awards/award9.webp').default,
        award10:require('./home-page-new/awards/award10.webp').default,
        award11:require('./home-page-new/awards/award11.webp').default,
        award12:require('./home-page-new/awards/award12.webp').default,
        mxSolutionIcon1:require('./home-page-new/mx/mx-sol-icon1.svg').default,
        mxSolutionIcon2:require('./home-page-new/mx/mx-sol-icon2.svg').default,
        mxSolutionIcon3:require('./home-page-new/mx/mx-sol-icon3.svg').default,
        subSol1:require('./home-page-new/mx/subSol1.svg').default,
        subSol2:require('./home-page-new/mx/subSol2.svg').default,
        subSol3:require('./home-page-new/mx/subSol3.svg').default,
        subSol4:require('./home-page-new/mx/subSol4.svg').default,
        subSol5:require('./home-page-new/mx/subSol5.svg').default,
        dottedBg:require('./home-page-new/credlix-home-dotted.png').default,
    },

    ABOUTIMG:{
        bannernew:require('./about-us/Topupcredit-pana.svg').default,
        spanishBanner:require('./about-us/about-banner-spanish.webp').default,
        portship:require('./about-us/Port-rafiki.svg').default,
        standinggirl:require('./about-us/Design-stats-rafiki.svg').default,
        rahulnew:require('./about-us/Rahul-new.webp').default,
        rishabhnew:require('./about-us/Rishabh-agarwal-new.webp').default,
        pritamnew:require('./about-us/Pramit-new.webp').default,
        sanjeevArora:require('./about-us/sanjeev-Arora.webp').default,
        GenetteNew:require('./about-us/Genette-Herrera.webp').default,
    },
    CONTACTIMG:{
        india:require('./contact-us/india.png').default,
        uae:require('./contact-us/uae.png').default,
        india_new:require('./contact-us/India-Contact.webp').default,
        uae_new:require('./contact-us/UAE-Contact.webp').default,
        singapore_new:require('./contact-us/Singapore-Contact.webp').default,
        location:require('./contact-us/map-pin-range-black.svg').default,
        contactus:require('./contact-us/contactus.webp').default,
    },

    CAREERIMG:{
        banner:require('./careers/career-banner.png').default,
        banner_mb:require('./careers/career-banner-mb.png').default,
        fearless:require('./careers/Group30320@2x.png').default,
        agility:require('./careers/Group30321@2x.png').default,
        integrity:require('./careers/Group30322@2x.png').default,
        collaboration:require('./careers/Group30323@2x.png').default,
        ownership:require('./careers/Group30327@2x.png').default,
        customer:require('./careers/Group30326@2x.png').default,
        innovation:require('./careers/Group30325@2x.png').default,
        people:require('./careers/Group30324@2x.png').default,
    },
  
    REQUESTDEMO:{
        requestDemoImage:require('./Request-Demo-Image.png').default
    },
    DOWNLOAD_SOLUTION_BRIEF:{
        requestDemoImage:require('./Download-Solutions-Image.png').default
    },
    ENTERPRISEIMG:{
        bannerEnterprise:require('./enterprise/For-Enterprise-Banner.png').default,
        banner:require('./enterprise/Enterprises_Page.png').default,
        iuj:require('./enterprise/Group-214114-1.svg').default,
        eoa:require('./enterprise/Group-254933-1.svg').default,
        sdda:require('./enterprise/Group-254996-1.svg').default,
        hcwfe:require('./enterprise/enterprise-boy.png').default,
        hcwfe_mb:require('./enterprise/enterprise-boy-mb.png').default,
   },
   PARTNERSHIP:{
        form:require('./Become-Partner-Image.png').default,
    },

    PURCHASEORDERFINANCE:{
       financeimg:require('./channel-finance/Group-25845.svg').default,
       customimg:require('./Group-25846.svg').default,
       crediline:require('./vendor-finance/Group-25847.svg').default,
       tech:require('./Group-25848.svg').default,
    },

    LEADGENIMG:{
        grow2x:require('./leadgen/Group-42883@2x.png').default,
        leadingimg:require('./leadgen/Group_42557@2x.png').default,
        integrated:require('./leadgen/Group-42562.svg').default,
        paymentdis:require('./leadgen/Group-42880.svg').default,
        protopay:require('./leadgen/Group_42544.svg').default,
        ontimepay:require('./leadgen/Group_42542.svg').default,
        repaycycle:require('./leadgen/Group_42545.svg').default,
        twiga:require('./leadgen/Group_37271@2x.png').default,
        lucro:require('./leadgen/Group_37300@2x.png').default,
        ldfood:require('./leadgen/Newldfoodlogo@2x.png').default,
        agarwal:require('./leadgen/Group-37301@2x.png').default,
},
DOWNLOAD_CASESTUDY:{
    leadingbrand:require('./case-study/leadingbrnd.png').default,
    dcasestudy:require('./case-study/caestudypopimage.png').default,
},

WEBINAR:{
    web1:require('./webinar/episode1.png').default,
    web2:require('./webinar/episode2.png').default,
    web3:require('./webinar/webinar3.webp').default,
    web4:require('./webinar/QuarterlyPartner.webp').default,
    web5:require('./webinar/IndiaMexicowebinar.webp').default,
},
HSNCODE:{
    banner:require('./hsn-code/hsn-Second-banner.png').default,
    hsn_img:require('./hsn-code/Bifurcation_of_HSN_Code.png').default,
    },
footer:{
        logo_new_credlix:require('./social-icon/CredlixWhite_logo_new.svg').default,
        logo_new_fci:require('./social-icon/FCI-logo.webp').default,
        whatsappScanner:require('./social-icon/whatsapp-scanner.webp').default,
        whatsAppIcon:require('./social-icon/whatsApp.gif').default,
},
calcInterest:{
    logoCredlix:require('./Shared/credlix-logo.png').default,
    socialPostImage:require('./interestCal/interest-cal.png').default,
    socialPostImageMexico:require('./interestCal/interest-cal-mexico.webp').default
},
credlixFinsight:{
    newFinsight:require('./credlixFinsight/newFinsight.webp').default,
},
webinarLp:{
    dF:require('./lead-magnet/df.webp').default,
    fB:require('./lead-magnet/fb.webp').default,
    iR:require('./lead-magnet/ir.webp').default,
    rbiLogo:require('./lead-magnet/RbiLogo.webp').default,
    rupees:require('./lead-magnet/rupees.svg').default,
    approval:require('./lead-magnet/approval.svg').default,
    interestRate:require('./lead-magnet/interestRate.svg').default,
    thankYouBG:require('./lead-magnet/thankYouBG.webp').default,
    documentmoney:require('./lead-magnet/documentmoney.svg').default,
},
appbanner:{
    googlePlayBtn:require('./appbanner/google-play-btn.webp').default,
    appStoreBtn:require('./appbanner/app-store-btn.webp').default,
    indiaTradeBanner:require('./appbanner/indiaTradeBanner.webp').default,
    floatingImage:require('./Shared/floating-image.webp').default,
    crossIcon:require('./Shared/Cross-icon.svg').default,
    appBg:require('./Shared/appBg.webp').default,
    mobileIcon:require('./Shared/mobileIcon.svg').default,
},
partnerProgram:{
    partnerbgDesktop:require('./partner-program/partnerbgDesktop.webp').default,
    partnerlogo:require('./partner-program/partnerlogo.webp').default,
    tenxFaster:require('./partner-program/10xFaster.webp').default,
    partnerGrow:require('./partner-program/partnerGrow.webp').default,
    Earnlogo:require('./partner-program/Earnlogo.webp').default,
    startEarning:require('./partner-program/startEarning.webp').default,
    boostBusiness:require('./partner-program/boostBusiness.webp').default,
    networklogo:require('./partner-program/networklogo.webp').default,
    globalImage:require('./partner-program/globalImage.webp').default,
    funds:require('./partner-program/funds.webp').default,
    staffing:require('./partner-program/staffing.webp').default,
    cities:require('./partner-program/cities.webp').default,
    signup:require('./partner-program/signup.webp').default,
    connect:require('./partner-program/connect.webp').default,
    rewardspartner:require('./partner-program/rewardspartner.webp').default,
    partnerlogoES:require('./partner-program/partnerlogoES.webp').default,
    partnerGrowES:require('./partner-program/partnerGrowES.webp').default,
    FinanciamientoES:require('./partner-program/FinanciamientoES.webp').default,
    signupES:require('./partner-program/signupES.webp').default,
    tenxFasterES:require('./partner-program/10xFasterES.webp').default,
    earlyPartner:require('./partner-program/EarlyPartner.svg').default,
    vendorPartner:require('./partner-program/vendorPartner.svg').default,
    thrivex:require('./partner-program/thrivex.webp').default,
    gestiónfinanciera:require('./partner-program/gestiónfinanciera.webp').default,
    impulsoHd:require('./partner-program/ImpulsoHd.webp').default,
},
 businessLoan:{
    businessLoanHome:require('./business-loan/business-loan.webp').default,
    loanFast:require('./business-loan/loanFast.webp').default,
    onlineLoan:require('./business-loan/onlineLoan.webp').default,
    timersLoan:require('./business-loan/TimersLoan.webp').default,
    fundsLoan:require('./business-loan/fundsLoan.webp').default,
    documentsLoan:require('./business-loan/DocumentsLoan.webp').default,
    keyFeatureLoan:require('./business-loan/KeyFeatureLoan.webp').default,
    trueLogoLoan:require('./business-loan/trueLogoLoan.svg').default,
    customer:require('./business-loan/customer.svg').default,
    loan:require('./business-loan/loan.svg').default,
    policy:require('./business-loan/policy.svg').default,
    website:require('./business-loan/websiteicon.svg').default,
    Grievance:require('./business-loan/Grievance.svg').default,
    dmiLogo:require('./business-loan/dmiLogo.svg').default,
    chooseIcon1:require('./business-loan/ChooseIocn1.svg').default,
    chooseIcon2:require('./business-loan/ChooseIocn2.svg').default,
    chooseIcon3:require('./business-loan/ChooseIocn3.svg').default,
    chooseIcon4:require('./business-loan/ChooseIocn4.svg').default,
    checkIcon:require('./business-loan/checkIcon.svg').default,
 },
 businessLoans:{
    keyFeatures:require('./business-loans/business-loan-key-feayures.svg').default,
    eligibility:require('./business-loans/eligibility-bg.webp').default,
    grievanceOfficer:require('./business-loans/grievance-officer.webp').default,
 },
globalBuyer:{
    globalbuyersNew:require('./globalBuyer/globalnew.webp').default,
    globalMask:require('./globalBuyer/globalMask.webp').default,
    exportBuyer:require('./globalBuyer/exportBuyer.webp').default,
    financeBuyer:require('./globalBuyer/financeBuyer.webp').default,
    paymentBuyer:require('./globalBuyer/paymentBuyer.webp').default,
    benefitsBuyers:require('./globalBuyer/benefitsBuyers.webp').default,
    relationshipBuyers:require('./globalBuyer/relationshipBuyers.webp').default,
    stabilityBuyers:require('./globalBuyer/stabilityBuyers.webp').default,
    efficiencyBuyers:require('./globalBuyer/efficiencyBuyers.webp').default,
    buyersDashboard:require('./globalBuyer/buyersDashboard.webp').default,
    buyersDashboardES:require('./globalBuyer/buyersDashboard-ES.webp').default,
    BenefitsBuyerImage:require('./globalBuyer/Benefits-Buyer.webp').default,
    BenefitsSupplier:require('./globalBuyer/Benefits-supplier.webp').default,
    checkboxBuyers:require('./globalBuyer/checkboxBuyers.svg').default,
    arrowBuyersDesktop:require('./globalBuyer/arrowBuyersDesktop.webp').default,
    arrowBuyersMobile:require('./globalBuyer/arrowBuyersMobile.webp').default,
    arrowBuyersDesktopES:require('./globalBuyer/arrowBuyersDesktop-ES.webp').default,
    arrowBuyersMobileES:require('./globalBuyer/arrowBuyersMobile-ES.webp').default,
    relationshipBuyersES:require('./globalBuyer/relationshipBuyersES.webp').default,
},
ExportFinancing:{
    bannerDesktop:require('./export-financing/ex-facbanner.webp').default,
    fundingIco1:require('./export-financing/fico1.svg').default,
    fundingIco2:require('./export-financing/fico2.svg').default,
    fundingIco3:require('./export-financing/fico1.svg').default,
    fundingIco4:require('./export-financing/fico4.svg').default,
    fundingIco5:require('./export-financing/fico5.svg').default,
    factor11:require('./export-financing/dfexport.webp').default,
    factor12:require('./export-financing/srProtect.webp').default,
    factor21:require('./export-financing/fact1.webp').default,
    factor22:require('./export-financing/fact2.webp').default,
    buyerElig:require('./export-financing/buyers-eligibilty.webp').default,
    icon1:require('./export-financing/Icon1.svg').default,
    icon2:require('./export-financing/Icon2.svg').default,
    icon3:require('./export-financing/Icon3.svg').default,
    icon4:require('./export-financing/Icon4.svg').default,
    hiw1:require('./export-financing/hiw1.webp').default,
    hiw2:require('./export-financing/hiw2.webp').default,
    hiw3:require('./export-financing/hiw3.webp').default,
    rbiLogo:require('./export-financing/Rbilogo.svg').default,
    gift:require('./export-financing/giftLogo.svg').default,
    cities:require('./export-financing/cities.svg').default,
    disbursed:require('./export-financing/disbursed.svg').default,
    MSMEs:require('./export-financing/MSMEs.svg').default,
    funding:require('./export-financing/funding.svg').default,
    videoThumb:require('./export-financing/videoThumb.webp').default,
},
  shipmentCalculator:{
        shipBanner:require('./shipment-calc/shipment-calc-bg.webp').default,
        fclicon:require('./shipment-calc/fclicon.svg').default,
        fcliconWhite:require('./shipment-calc/fclicon-white.svg').default,
        shipImg:require('./shipment-calc/shipment.svg').default,
        shipImgWhite:require('./shipment-calc/shipment-white.svg').default,
        plane:require('./shipment-calc/plane.svg').default,
        planeWhite:require('./shipment-calc/plane-white.svg').default,
        truck:require('./shipment-calc/truck.svg').default,
        truckWhite:require('./shipment-calc/truck-white.svg').default,
        quotesLogo : require('./shipment-calc/quote-logo.webp').default,
        originIcon: require('./shipment-calc/origin.svg').default,
        destinationIcon: require('./shipment-calc/destination.svg').default,
        costcalcBg: require('./shipment-calc/cost-calc-bg.webp').default,
        shipmentOne: require('./shipment-calc/shipment-one.webp').default,
        benefitTime: require('./shipment-calc/instant-real-quotes.svg').default,
        shippingNeeds: require('./shipment-calc/shipping-needs.svg').default,
        globalCoverage: require('./shipment-calc/global-coverage.svg').default,
        optimizeSupplyChain: require('./shipment-calc/optimize-supply-chain.svg').default,
        shipmentDetails: require('./shipment-calc/shipment-details.svg').default,
        realTimeQuotes: require('./shipment-calc/real-time-quotes.svg').default,
        comparePlan: require('./shipment-calc/compare-plan.svg').default,
        arrowPath: require('./shipment-calc/arrow-path.svg').default,
        features: require('./shipment-calc/features.webp').default,  
        calculatorIcon: require('./shipment-calc/calculator.svg').default,
        planningSmarter: require('./shipment-calc/planning-smarter.svg').default,
        shippingExpense: require('./shipment-calc/shipping-expense.svg').default,
        saveTime: require('./shipment-calc/save-time.svg').default,
    },
    homepageBanner:{
        CredlixBannerDes:require("./expo-trade/expoTradeDes.webp").default,
        CredlixBannerMobile:require("./expo-trade/expoTradeMobile.webp").default,
    },
    termsheet:{
        chartTermsheet:require("./termsheet/ChartTermsheet.webp").default,
        Values:require("./termsheet/Values.webp").default,
        document:require("./termsheet/document.svg").default,
        secure:require("./termsheet/secure.svg").default,
        quick:require("./termsheet/quick.svg").default,
        easy:require("./termsheet/easy.svg").default,
        security:require("./termsheet/security.svg").default,
        analysis:require("./termsheet/analysis​.svg").default,
        realTime:require("./termsheet/realTime.svg").default,
        check:require("./termsheet/Checkicon.svg").default,
        BackgroundBanner:require("./termsheet/Background-Banner.webp").default,
        ManTerms:require("./termsheet/Man.webp").default,
        RiskMeter:require("./termsheet/Risk-Meter.webp").default,
    },
    businessLoansPages:{
        desktopBanner:require("./business-loans/bl_banner.webp").default,
        womania:require("./business-loans/womania.webp").default,
        BC_agriculture:require("./business-loans/bc_agriculture.webp").default,
        agriculture:require("./business-loans/agriculture.webp").default,
        Bc_msme:require("./business-loans/bc_msme.webp").default,
        msme:require("./business-loans/msme.webp").default,
        BC_startups:require("./business-loans/bc_startups.webp").default,
        startups:require("./business-loans/startups.webp").default,
        defaultBanner:require("./business-loans/defaultbusinessbanner.webp").default,
        defaultMbBanner:require("./business-loans/defaultBannerMb.webp").default,
        exportFactoringBanner:require("./business-loans/exportFactoring.webp").default,
        exportFactoringBannerMb:require("./business-loans/exportFactoringMb.webp").default,
        otherServBanner:require("./business-loans/otherServPages.webp").default,
        otherServBannerMb:require("./business-loans/otherServPagesMb.webp").default,
    },
    mexicoIndiaTrade:{
        banner:require("./mexico-india-trade/banner-bg.webp").default,
        bannerCreative1:require("./mexico-india-trade/mi-Creative1.webp").default,
        bannerCreative2:require("./mexico-india-trade/mi-Creative2.webp").default,
        dollarIcon:require("./mexico-india-trade/dollar.svg").default,
        connectIcon:require("./mexico-india-trade/connect.svg").default,
        buildingIcon:require("./mexico-india-trade/building.svg").default,
        mapIcon:require("./mexico-india-trade/mapicon.svg").default,
        horseIcon:require("./mexico-india-trade/horseIcon.svg").default,
        cbCreative1:require("./mexico-india-trade/supplierCre.webp").default,
        cbCreative2:require("./mexico-india-trade/buyersCre.webp").default,
        wcCredImage1:require("./mexico-india-trade/aione.svg").default,
        wcCredImage2:require("./mexico-india-trade/Development.svg").default,
        wcCredImage3:require("./mexico-india-trade/global.svg").default,
        wcCredImage4:require("./mexico-india-trade/network.svg").default,
        wcCredImage5:require("./mexico-india-trade/powered.svg").default,
        whyMexicoTrade:require("./mexico-india-trade/whyMexicotrade.webp").default,
        settingImage:require("./mexico-india-trade/setting.webp").default,
        impact:require("./mexico-india-trade/parallax-bg.webp").default,
        worldMap:require("./mexico-india-trade/mapworld.webp").default,
    },
    POFinance:{
        bgBanner:require("./po-finance/Group-258212x.webp").default,
        poBannerBg:require("./po-finance/Banner_img@2x-1.webp").default,
    },
    MachineryLoan:{
        bgBannerDesktop:require("./machinery-loan/bannerDesktop.webp").default,
        bgBannerMobile:require("./machinery-loan/bannerMobile.webp").default,
        tenureupto:require('./machinery-loan/noun-funds-immediately.svg').default,
        competitiveInterest:require('./machinery-loan/Iocn.svg').default,
        loanSignificant:require('./machinery-loan/noun-working-capital.svg').default,
        enchanced:require('./machinery-loan/enhanced.svg').default,
        compliance:require('./machinery-loan/compliance.svg').default,
        strategic:require('./machinery-loan/strategic.svg').default,
        ethos:require('./machinery-loan/ethos.svg').default,
        industrialPlant:require('./machinery-loan/challenegeImage.webp').default,
        creditcheck:require('./machinery-loan/creditcheck.svg').default,
        reports:require('./machinery-loan/reports.svg').default,
        analysis:require('./machinery-loan/analysis.svg').default,
    },
    FreightLoan:{
    bgBannerDesktop:require("./freight-loan/bannerDesktop.webp").default,
    bgBannerMobile:require("./freight-loan/bannerMobile.webp").default,
    instant:require('./freight-loan/instant.svg').default,
    saveMore:require('./freight-loan/saveMore.svg').default,
    cash:require('./freight-loan/cash.svg').default,
    pay:require('./freight-loan/pay.svg').default,
    reallocate:require('./freight-loan/trend-up.svg').default,
    building:require('./freight-loan/building.svg').default,
    stockContainer:require("./freight-loan/stock-container.webp").default,
    },
    ImportFactoring:{
     bgBannerDesktop:require("./import-factoring/bannerDesktop.webp").default,
     bgBannerMobile:require("./import-factoring/bannerMobile.webp").default,
     texttile:require('./import-factoring/textile.svg').default,
     electronics:require('./import-factoring/Electronics.svg').default,
     sme:require('./import-factoring/sme.svg').default,
     scale:require('./import-factoring/scale.svg').default,
     applyOnline:require('./import-factoring/applyOnline.svg').default,
     approved:require('./import-factoring/get-approved.svg').default,
     paysuppiler:require('./import-factoring/suppiler.svg').default,
     rePay:require('./import-factoring/rePay.svg').default,
     doubleBg:require('./import-factoring/doubleBg.webp').default,
     average:require('./import-factoring/average.svg').default,
     cash:require('./import-factoring/cash.svg').default,
     calender:require('./import-factoring/calender.svg').default,
     yes:require('./import-factoring/yes.svg').default,
     no:require('./import-factoring/no.svg').default,
     financing:require('./import-factoring/Off-Balance-Sheet.svg').default,
     collateral:require('./import-factoring/collateral.svg').default,
     disbursals:require('./import-factoring/Lightning-Fast.svg').default,
     digitalPlatform:require('./import-factoring/Fully-Digital.svg').default,
     mexicoImportBanner:require("./import-factoring/mexicoImportBanner.webp").default,
     ImportBGBanner:require("./import-factoring/importBg.webp").default,
    },
    professionalsLoan:{
        professionalsDesktop:require("./professionals-loan/professionalsDesktop.webp").default,
        digitalAssets:require("./professionals-loan/digitalAssets.webp").default,
        vision:require('./professionals-loan/vision.svg').default,
        rates:require('./professionals-loan/rates.svg').default,
        tailored:require('./professionals-loan/tailored-Repayment.svg').default,
        loanAmount:require('./professionals-loan/loan-amount.svg').default,
        interest:require('./professionals-loan/interest.svg').default,
        tenure:require('./professionals-loan/tenure.svg').default,
        collateral:require('./professionals-loan/collateral.svg').default,
        eligibility:require('./professionals-loan/eligibility.svg').default,
        turnover:require('./professionals-loan/turnover.svg').default,
        age:require('./professionals-loan/business-age.svg').default,
        applicantAge:require('./professionals-loan/applicant-age.svg').default,
        caBanner:require('./professionals-loan/CAImage.webp').default,
        loanCollateral:require('./professionals-loan/collateral-icon.svg').default,
        lightning:require('./professionals-loan/lighting.svg').default,
        documentaion:require('./professionals-loan/document.svg').default,
        doctors:require('./professionals-loan/doctors.svg').default,
        CharteredAccountants:require('./professionals-loan/caImageShort.webp').default,
    },  
    suppilerEvent:{
        CredlixLogo:require("./suppiler-event/CredlixLogo.svg").default,
        eventBanner:require("./suppiler-event/eventImage.webp").default,
        suppilerHeroBanner:require("./suppiler-event/suppilerHeroBanner.webp").default,
        bgBannerSuppiler:require("./suppiler-event/bgBannerSuppiler.webp").default,
        bgBannerBuyer:require("./suppiler-event/bgBannerBuyer.webp").default,
        yes:require("./suppiler-event/Yes.svg").default,
        sellerImage:require("./suppiler-event/sellerImage.webp").default,
        agenda1bg:require("./suppiler-event/agenda1.webp").default,
        agenda2bg:require("./suppiler-event/agenda2bg.webp").default,
        gold:require("./suppiler-event/gold.svg").default,
        sliver:require("./suppiler-event/sliver.svg").default,
        yellowCheck:require("./suppiler-event/yesYellow.svg").default,
        sliveCheck:require("./suppiler-event/checkbox.svg").default,
        eventbgSuppiler:require("./suppiler-event/eventbgSuppiler.webp").default,
        eventbgBuyer:require("./suppiler-event/eventbgbuyer.webp").default,
        innovation:require("./suppiler-event/innovation.svg").default,
        quality:require("./suppiler-event/quality.svg").default,
        pricing:require("./suppiler-event/pricing.svg").default,
        mexicoIndia:require("./suppiler-event/75years.webp").default,
        electronics:require("./suppiler-event/electronics.svg").default,
        equipment:require("./suppiler-event/equipment.svg").default,
        automotive:require("./suppiler-event/automotive.svg").default,
        steel:require("./suppiler-event/steel.svg").default,
        plastics:require("./suppiler-event/plastics.svg").default,
        textile:require("./suppiler-event/textile.svg").default,
        fifoLogo:require("./suppiler-event/fifologo.webp").default,
        coppel:require("./suppiler-event/coppel.webp").default,
        enviaflores:require("./suppiler-event/enviaflores.svg").default,
        liverpool:require("./suppiler-event/liverpool.svg").default,
        fiEo:require("./suppiler-event/fieo.svg").default,
        aet:require("./suppiler-event/aet.webp").default,
        indiaPlastic:require("./suppiler-event/indianPlastics.svg").default,
        pharmexcil:require("./suppiler-event/pharmexcil.svg").default,
        cii:require("./suppiler-event/cii.svg").default,
        antad:require("./suppiler-event/antad.svg").default,
        comce:require("./suppiler-event/comce.svg").default,
        caintra:require("./suppiler-event/caintra.svg").default,
        indiaMexico:require("./suppiler-event/indiaMexico.svg").default,
        expoHall:require("./suppiler-event/exphoEvent.webp").default,
        eventTimeTable:require("./suppiler-event/eventTimeTAble.webp").default,
        mexico75Years:require("./suppiler-event/mexico75Years.webp").default,
        eventBannerMexico:require("./suppiler-event/eventBannerMexico.webp").default,
        aboutSays:require("./suppiler-event/aboutSays.svg").default,
        embassy:require("./suppiler-event/embassyVideo.webp").default,
        voiceTrust:require("./suppiler-event/voiceTrustVideo.webp").default,
        indiaTealogo:require("./suppiler-event/indiaTealogo.webp").default,
        webinarThum:require("./suppiler-event/webinarThumb.webp").default,
    },
    login:{
        profile:require("./login/profile.svg").default,
        credlixLogo:require("./login/CredlixLogo.svg").default,
        profileLogin:require("./login/profileLogin.svg").default,
        loginIcon:require("./login/login-icon.png").default,
        loginBusiness:require("./login/loginBusiness.webp").default,
    },
    financeSolution:{
        earlyPayment:require("./finance-solution/early-payment.svg").default,
        vendorFinance:require("./finance-solution/vendor-finance.svg").default,
        channelFinance:require("./finance-solution/channel-finance.svg").default,
        businessLoan:require("./finance-solution/business-loan.png").default,
        salesBillDisc:require("./finance-solution/sales-bill-disc.svg").default,
        exportFactoring:require("./finance-solution/export-factoring.svg").default,
        importFactoring:require("./finance-solution/import-factoring.svg").default,
        poFinance:require("./finance-solution/po-finance.svg").default,
    },
    corporateLoan:{
        bgCorporateDesktop:require("./corporateLoan/corporateBanner.webp").default,
        bgCorporateMb:require("./corporateLoan/corporateBannerMb.webp").default,
        building:require("./corporateLoan/building.webp").default,
        expansion:require("./corporateLoan/expansion.webp").default,
        capital:require("./corporateLoan/capital.webp").default,
        equity:require("./corporateLoan/equity.webp").default,
        blanceSheet:require("./corporateLoan/blanceSheet.webp").default,
        lapHome:require("./corporateLoan/lapHome.webp").default,
        financing:require("./corporateLoan/financing.webp").default,
        industrial:require("./corporateLoan/Industrial.svg").default,
        commercial:require("./corporateLoan/commercial.svg").default,
        warehouses:require("./corporateLoan/warehouses.svg").default,
        revenue:require("./corporateLoan/revenue.svg").default,
        manufacturing:require("./corporateLoan/manufacturing.svg").default,
        approval:require("./corporateLoan/approval.svg").default,
        builts:require("./corporateLoan/builts.svg").default,
        structured:require("./corporateLoan/structured.svg").default,
        rbi:require("./corporateLoan/rbi.svg").default,
        panIndia:require("./corporateLoan/panIndia.svg").default,
        howitworksBg:require("./corporateLoan/howitworksBg.webp").default,
    },
    dealerFinancing:{
        dealerImage:require("./dealerFinancing/dealerImage.webp").default,
        featureBg:require("./dealerFinancing/featureBg.webp").default,
        billing:require("./dealerFinancing/billing.svg").default,
        seo:require("./dealerFinancing/seo.svg").default,
        channel:require("./dealerFinancing/channel.svg").default,
        RBILogo:require("./dealerFinancing/rbiLogo.svg").default,
        msme:require("./dealerFinancing/msme.svg").default,
        cities:require("./dealerFinancing/cities.svg").default,
        ERP:require("./dealerFinancing/erp.svg").default,
        fmcg:require("./dealerFinancing/fmcg.svg").default,
        durables:require("./dealerFinancing/durables.svg").default,
        pcb:require("./dealerFinancing/pcb.svg").default,
        pharma:require("./dealerFinancing/pharma.svg").default,
        dealers:require("./dealerFinancing/dollar-fill.svg").default,
        invontory:require("./dealerFinancing/clock-countdown.svg").default,
        document:require("./dealerFinancing/document.svg").default,
        credit:require("./dealerFinancing/chart-line-.svg").default,
        distributor:require("./dealerFinancing/distributor.svg").default,
        oems:require("./dealerFinancing/oems.webp").default,
        improvement:require("./dealerFinancing/improvement.webp").default,
        Offbalance:require("./dealerFinancing/Off-balance-sheet.webp").default,
        ERPintegrated:require("./dealerFinancing/ERP-integrated.webp").default,
        algorithm:require("./dealerFinancing/algorithm-based.webp").default,
    },
    machineryFinancing:{
        cash:require("./machineryFinancing/cash.svg").default,
        import:require("./machineryFinancing/import.svg").default,
        fatser:require("./machineryFinancing/faster.svg").default,
        engineering:require("./machineryFinancing/engineering.svg").default,
        molding:require("./machineryFinancing/molding.svg").default,
        packing:require("./machineryFinancing/packing.svg").default,
        textile:require("./machineryFinancing/textile.svg").default,
        semiconductor:require("./machineryFinancing/semiconductor.svg").default,
        construction:require("./machineryFinancing/construction.svg").default,
        capesBg:require("./machineryFinancing/capesBg.webp").default,
        watchImage:require("./machineryFinancing/watchImage.webp").default,
        realTime:require("./machineryFinancing/realtime.webp").default,
        detailReport:require("./machineryFinancing/detailreport.webp").default,
        indepth:require("./machineryFinancing/indepth.webp").default,
    },
    exportInterest:{
        exportInterestBg:require("./export-interest/exportInterestBg.webp").default,
        exportInterestBgMobile:require("./export-interest/exportInterestBgMobile.webp").default,
        fci:require("./export-interest/fci.svg").default,
        payment:require("./export-interest/payment.svg").default,
        bankCredit:require("./export-interest/bankCredit.svg").default,
        risk:require("./export-interest/risk.svg").default,
        processCenterpiece:require("./export-interest/process_centerpiece.webp").default,
        lowerCost:require("./export-interest/lowerCost.webp").default,
        betterCash:require("./export-interest/betterCash.webp").default,
        lowerRisk:require("./export-interest/lowerRisk.webp").default,
        lowerBG:require("./export-interest/lowerBG.webp").default,
        stepBG:require("./export-interest/stepBG.webp").default,
    },
    inrxpress:{
        credlixremitLogo:require("./inrxpress/credlixremitLogo.webp").default,
        inrxpressBgDp:require("./inrxpress/inrxpressBgDp.webp").default,
        inrxpressBgMobile:require("./inrxpress/inrxpressBgMobile.webp").default,
        inrxpressCurrency:require("./inrxpress/inrxpressCurrencyNew.webp").default,
    }
}
export default IMAGES;